import React from 'react';
import { Offcanvas, Nav, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { HouseDoor, Person, Newspaper, Chat, Gear, BookmarkHeart, Calendar, Collection, Bell } from 'react-bootstrap-icons';
import './Css/Sidebar.css';

import userAvatar from '../img/akash1.jpg';

function Sidebar({ show, handleClose }) {
  return (
    <Offcanvas show={show} onHide={handleClose} className="custom-sidebar">
      {/* User Profile Section */}
      <div className="sidebar-user-section">
        <Image
          src={userAvatar}
          roundedCircle
          className="sidebar-avatar"
        />
        <h6 className="mb-1">Akash GC</h6>
        <p className="text-muted small mb-3">Premium Member</p>
        <div className="user-stats d-flex justify-content-center gap-3">
          <div className="stat-item">
            <div className="stat-value">254</div>
            <div className="stat-label">Posts</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">12.4k</div>
            <div className="stat-label">Followers</div>
          </div>
        </div>
      </div>

      <Offcanvas.Body className="p-0">
        {/* Main Navigation */}
        <div className="sidebar-section">
          <h6 className="sidebar-heading">Main Navigation</h6>
          <Nav className="flex-column">
            <Nav.Link as={Link} to="/" onClick={handleClose}>
              <HouseDoor size={18} className="me-2" />
              Dashboard
            </Nav.Link>
            <Nav.Link as={Link} to="/profile" onClick={handleClose}>
              <Person size={18} className="me-2" />
              Profile
            </Nav.Link>
            <Nav.Link as={Link} to="/blog" onClick={handleClose}>
              <Newspaper size={18} className="me-2" />
              Blog Posts
            </Nav.Link>
            <Nav.Link as={Link} to="/messages" onClick={handleClose}>
              <Chat size={18} className="me-2" />
              Messages
              <span className="badge bg-danger ms-2">3</span>
            </Nav.Link>
          </Nav>
        </div>

        {/* Content Management */}
        <div className="sidebar-section">
          <h6 className="sidebar-heading">Content Management</h6>
          <Nav className="flex-column">
            <Nav.Link as={Link} to="/calendar" onClick={handleClose}>
              <Calendar size={18} className="me-2" />
              Calendar
            </Nav.Link>
            <Nav.Link as={Link} to="/collections" onClick={handleClose}>
              <Collection size={18} className="me-2" />
              Collections
            </Nav.Link>
            <Nav.Link as={Link} to="/favorites" onClick={handleClose}>
              <BookmarkHeart size={18} className="me-2" />
              Favorites
            </Nav.Link>
          </Nav>
        </div>

        {/* Settings Section */}
        <div className="sidebar-section">
          <h6 className="sidebar-heading">Settings</h6>
          <Nav className="flex-column">
            <Nav.Link as={Link} to="/notifications" onClick={handleClose}>
              <Bell size={18} className="me-2" />
              Notifications
              <span className="badge bg-primary ms-2">5</span>
            </Nav.Link>
            <Nav.Link as={Link} to="/settings" onClick={handleClose}>
              <Gear size={18} className="me-2" />
              Settings
            </Nav.Link>
          </Nav>
        </div>

        {/* Pro Features Banner */}
        <div className="sidebar-banner">
          <div className="banner-content">
            <h6 className="mb-2">Upgrade to Pro</h6>
            <p className="small mb-2">Get access to premium features</p>
            <button className="btn btn-light btn-sm w-100">
              Upgrade Now
            </button>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Sidebar; 